import { render, staticRenderFns } from "./HandHeartIcon.vue?vue&type=template&id=aa1a7a6a"
import script from "./HandHeartIcon.vue?vue&type=script&lang=js"
export * from "./HandHeartIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports